import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import HeaderItems from "./headeritems";
import '../../css/NavMenu.css';

export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 'tab_eventlogs',
            activeEL: true,
            activeGM: false
        }
    }
    componentWillReceiveProps(nextProps) {
        if (Object.keys(nextProps).length !== 0 && nextProps.constructor === Object) {
            if (nextProps.urls.urls != null && typeof (nextProps.urls.urls) != "undefined" && nextProps.urls.urls.length > 0) {
                var headerUrls = nextProps.urls.urls;
                HeaderItems[0].link = "/";
                HeaderItems[1].link = headerUrls[3].value;
                HeaderItems[2].link = headerUrls[4].value;
            }
        }
    }
    componentWillMount() {
        ////this.props.onRequestUrls();
        let currentLocation = window.location.href.split("/")[3];
        //this.activeNav("tab_generatedmessage");
        //(currentLocation === "") ? this.activeNav("c") : this.activeNav(currentLocation);
        switch (currentLocation) {
            case "":
                this.activeNav("tab_eventlogs");
                break;
            case "CustomerMessageTriggers":
                this.activeNav("tab_eventlogs");
                break;
            case "CustomerMessages":
                this.activeNav("tab_generatedmessage");
                break;
            default:
                this.activeNav("tab_eventlogs");
                break;
        }
    }
    activeNav(item) {
        if (item === 'tab_eventlogs') {
            this.setState({
                activePage: 'tab_eventlogs',
                activeEL: true,
                activeGM: false
            });
        }
        else if (item === 'tab_generatedmessage') {
            this.setState({
                activePage: 'tab_generatedmessage',
                activeEL: false,
                activeGM: true
            });
        }
    }

    getNavItemClass(item) {
        if (item === 'tab_eventlogs') return (this.state.activeEL) ? 'nav-item active' : 'nav-item';
        else if (item === 'tab_generatedmessage') return (this.state.activeGM) ? 'nav-item active' : 'nav-item';
    }

    render() {
        return (
            <header className="ds-header app-logged-in">
                <nav className="navbar large-nav-menu">
                    <Link to="#/" className="navbar-brand">
                        <span className="damco-logo pull-left dam-logo__img" title="Damco"></span>
                    </Link>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav">
                            {
                                HeaderItems.map((item, index) => {
                                      return (
                                            <li className={this.getNavItemClass(item.activeNav)} key={`item-${index}`}>
                                                <a href={item.link} onClick={() => this.activeNav(item.activeNav)}
                                                    className="nav-link link">
                                                    {item.label}
                                                </a>
                                            </li>
                                        )
                                })
                            }
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }
}
//const mapStateToProps = (state) => {
//    return {
//        urls: state.urlsReducer
//    };
//};
//const mapDispatchToProps = (dispatch) => {
//    return {
//        onRequestUrls: () => {
//            dispatch(requestUrls());
//        }
//    };
//};
//export default connect(mapStateToProps, mapDispatchToProps)(Header);
export default (Header);
